module.exports = __webpack_public_path__ + "static/media/lungs.6db500a8.png";